import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import {ViewService} from "../../../services/common/view.service";


// type Layout =
//   "chip-lbl" |
//   "item";


@Component({
  selector: 'app-popover-map-type',
  templateUrl: './popover-map-type.component.html',
  styleUrls: ['./popover-map-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopoverMapTypeComponent implements OnInit {


  // component args

  // @Input() arg;



  opts = [
    {
      id: "road",
      lbl: "POP_MAP_TYPE.mappa_stradale",
    },
    {
      id: "satellite",
      lbl: "POP_MAP_TYPE.mappa_satellitare",
    },
  ];



  // listener

  listener = {
    view: null,
  };


  constructor(
    private cd: ChangeDetectorRef,
    // private navCtrl: NavController,
    // navParams can only be used in modals and popovers!
    // private navParams: NavParams,
    // private tdweb: TdwebService,
    // private dataService: DataService,
    private popoverCtrl: PopoverController,
    // private alertCtrl: AlertController,
    // private modalCtrl: ModalController,
    // private api: ApiService,
    private view: ViewService,
    // private menuCtrl: MenuController,
  ) {}



  ngOnInit() {}


  ionViewWillEnter() {
  }


  ionViewDidEnter() {
    this.listenerView();
  }


  ionViewWillLeave() {
    if (this.listener.view) {
      this.listener.view.unsubscribe();
    }
  }


  ionViewDidLeave() {
  }


  // ngOnDestroy() {}





  /*myFunc() {
    console.log("myfunc", typeof this.val == 'number')
    return typeof this.val == 'number';
  }*/




  async dismiss(action: string) {
    await this.popoverCtrl.dismiss({ action: action })
  }




  // listener

  listenerView() {
    this.listener.view = ViewService.updateView$.subscribe((obj?: any) => {
      // console.log("listener.view", obj);

      // this.zone.run(() => {

      this.view.pipeChanged++;
      this.cd.markForCheck();

      setTimeout(() => {
        this.cd.markForCheck();
      }, 250);

      // });
    });
  }
















}

